const MOCK_ANALYSIS = `# Italy Security Situation Report

**Classification:** UNCLASSIFIED
**Period:** April 2026
**Region:** Southern Europe

---

## Executive Summary

The security situation in Italy remains stable with localized risks in southern regions. Recent flooding in the Adriatic coast has prompted emergency response measures and elevated the risk of secondary civil unrest in affected communities.

## Key Findings

- **Natural Disaster Impact:** Early-April flooding in Abruzzo and Marche regions displaced approximately 12,000 residents. Recovery operations are ongoing with international aid arriving from EU partners.

- **Political Stability:** The coalition government maintains a parliamentary majority. No significant threats to governmental continuity are anticipated in the near term.

- **Organized Crime:** Camorra activity in Campania shows increased logistics operations, likely exploiting disruptions caused by flooding. Law enforcement has increased patrols in affected zones.

- **Protest Activity:** Environmental groups staged demonstrations in Rome (April 14) and Milan (April 18) with combined attendance of ~3,000. Both events remained peaceful.

## Risk Assessment

| Domain | Level | Trend |
|--------|-------|-------|
| Political | Low | Stable |
| Civil Unrest | Low-Medium | Increasing |
| Terrorism | Low | Stable |
| Natural Hazard | Medium | Decreasing |

## Recommendations

1. Monitor flood recovery operations for secondary civil unrest triggers
2. Maintain standard security protocols for business travel to southern regions
3. Review contingency plans for Naples and Palermo offices given organized crime activity

---
*Analysis generated for internal use only.*`;

export const streamMock = async (
  onChunk: ((chunk: string) => void) | undefined,
  onComplete: (() => void) | undefined,
  signal: AbortSignal,
  threadId: string
) => {
  await new Promise(resolve => setTimeout(resolve, 400));

  if (signal.aborted) return;

  onChunk?.(JSON.stringify({ analysis_thread_id: threadId }));

  const words = MOCK_ANALYSIS.split(' ');
  const chunkSize = 6;

  for (let i = 0; i < words.length; i += chunkSize) {
    if (signal.aborted) return;

    const slice =
      words.slice(i, i + chunkSize).join(' ') + (i + chunkSize < words.length ? ' ' : '');

    onChunk?.(slice);
    await new Promise(resolve => setTimeout(resolve, 40));
  }

  if (signal.aborted) return;

  onChunk?.(
    JSON.stringify({
      type: 'completed',
      text: MOCK_ANALYSIS,
      analysis_thread_id: threadId,
      tokens_used: {
        total_tokens: 100,
        input_tokens: 60,
        output_tokens: 40,
        file_tokens: 0,
      },
      file_ids: [],
    })
  );

  if (!signal.aborted) {
    onComplete?.();
  }
};
